const version = {
    number: 7.83
}

export default version;
